import React from 'react';

export default function Loading() {
  return (
    <div className='container d-flex justify-content-center'>
      <img src='/img/Loadingicon.gif' className='loadingicon' />
    </div>
  );
}
